<template>
	<div id="app">
		{{ stateSync }}
		<div class="route_part">
			<router-view />
		</div>
		<Internet />
	</div>
</template>
<script>
import Internet from "./components/fixedcomponents/Internet.vue";
import { refreshAccessToken } from "./utils/request";
import {
  startTokenExpiryWatcher,
} from "./utils/tokenCheck";
import { checkAccess } from "./permission";

export default {
	components: { Internet },
	data() {
		return {
			mini: true,
		};
	},
	// Save data on reload
	computed: {
		stateSync() {
			let stt = this.$store.state;
			localStorage.setItem("simpAdminState", JSON.stringify(stt));
			return "";
		},
	},
	created() {
		let savedstate = localStorage.getItem("simpAdminState");
		if (savedstate != null) {
			this.$store.replaceState(JSON.parse(savedstate));
		}
		if (checkAccess()) {
			refreshAccessToken();
			startTokenExpiryWatcher();
		}
	},
	methods: {
		toggleSidebar() {
			if (this.mini) {
				document.getElementById("main").style.marginLeft = "250px";
				this.mini = false;
			} else {
				document.getElementById("main").style.marginLeft = "85px";
				this.mini = true;
			}
		},
	},
};
</script>
<style>
body {
	font-family: "Poppins", sans-serif;
}
</style>
<style scoped>
.container-fluid {
	width: 100%;
	padding-right: 0px;
	padding-left: 0px;
	margin-right: 0px;
	margin-left: 0px;
}
</style>
